/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetWayWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {TombstoneIndividualWPView} from "./TombstoneIndividualWPView";
import {TombstoneNoMercy} from "../../TombstoneNoMercy";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BetWayWin, TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";

export class TombstoneIndividualWPController extends BetWayWinIndividualWPController {

    private _view:TombstoneIndividualWPView;
    private ovrConf:IIndividualWinPresentationConfig;
    private _winTextPosition:PIXI.Point;
    private _belowStakeWinRestriction:boolean;

    constructor(config:IIndividualWinPresentationConfig) {
        super(config);

        this._view = new TombstoneIndividualWPView();
        this.ovrConf = config;
        TombstoneNoMercy.individualWin = this;
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        if(super.parseFeatureGameData) {
            super.parseFeatureGameData(data);
        }
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue(data.totalWin, data.playedBetValue);
        StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.INDIVIDUAL_WIN.name).visible = !this._belowStakeWinRestriction;
    }

    protected getLineAnimation(betWayWinData:IBetWayWinData):Timeline {
        this._winTextPosition = this.getWinTextPosition(betWayWinData.reelWinPositions);
        const timeline:TimelineLite = new TimelineLite();
        const reelsNum:number = betWayWinData.length;
        let currentDuration:number = 0;


        if(TombstoneGameModuleConfig.gameData.isWinAboveStake()) {
            for (let i: number = 0; i < reelsNum; i++) {
                for (let j: number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                    if (betWayWinData.reelWinPositions[i][j]) {
                        const symbol = Reels.getSymbol(i, j);
                        if (symbol) {
                            this.addSymbolWinAnimationToTimeline(betWayWinData, timeline, this.ovrConf.symbolTimeOffsetCalculator(currentDuration, i, j), symbol, i, j);
                            if (this._winSymbols.indexOf(symbol) === -1) {
                                this._winSymbols.push(symbol);
                            }
                        }
                    }
                }
                currentDuration = timeline.totalDuration();
            }

            timeline.add(TweenLite.to(this._view, 1, {alpha: 0.5}));
        }

        return timeline;
    }

    private getWinTextPosition(reelWinPositions:boolean[][]):PIXI.Point {
        for(let reelId = reelWinPositions.length - 1; reelId >= 0; reelId--) {
            for(let symId = 0; symId < 3; symId++) {
                if(reelWinPositions[reelId][symId] && !Reels.getSymbol(reelId, symId)?.symName.includes("W")) {
                    return new PIXI.Point(reelId, symId);
                }
            }
        }
        return new PIXI.Point(0, reelWinPositions[0].indexOf(true));
    }


    /*protected getLineAnimation(betWayWinData:IBetWayWinData):Timeline {
        const timeline:Timeline = super.getLineAnimation(betWayWinData);
        timeline.add(TweenLite.to(this._view, 1, {alpha : 0.5}));

        return timeline;
    }*/

    protected getLineAnimRemade():Timeline {
        const tl:TimelineLite = new TimelineLite();
        const symIds: string [] = [];
        const lengths: number [] = [];

        const winPositionsByClient: PIXI.Point [][] = [];


        if(this._betWinsData) {
            this._betWinsData.forEach((winData) => {
                winPositionsByClient.push((<TombstoneParsedGameData>this._gameData).getWinPositions(winData.symbol, (<BetWayWin>winData).length));
            });
        }


        return tl;
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        if(symbol.symName.indexOf("W") > -1 && symbolId != 1) {
            return;
        }

        const position:[number, number] = Helper.getSymbolPositions(reelId, symbolId);
        //timeline.add(this._view.getToggleOverlayToTimeline(position, symbol.symName.indexOf("W") > -1), startTime);
        timeline.add(this._view.getToggleOverlayToTimeline(betWayWinData, position, symbol.symName.indexOf("W") > -1, this._betWinsData!.length > 1 && reelId === this._winTextPosition.x && symbolId === this._winTextPosition.y && !this._belowStakeWinRestriction), startTime);
    }

    public abort(){
        this.stopWinPresentation(true);
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);

        this._view.stopWinPresentation();
    }
}